import { Billboard, Text } from "@react-three/drei";

// Ground-level world title, visible immediately from spawn without needing
// to look up (camera pitch is fixed and can't aim skyward).
export default function WorldTitleSign() {
  return (
    <group position={[0, 0, 13]}>
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.03, 0]}>
        <circleGeometry args={[4, 40]} />
        <meshBasicMaterial color="#FF007F" transparent opacity={0.05} toneMapped={false} />
      </mesh>
      <Billboard position={[0, 5.2, 0]}>
        <Text fontSize={0.85} color="#FF007F" anchorX="center" anchorY="middle" letterSpacing={0.04}>
          ADLAN MS'S WORLD
        </Text>
      </Billboard>
      <Billboard position={[0, 3.9, 0]}>
        <Text fontSize={0.35} color="#8A9AAB" anchorX="center" anchorY="middle" letterSpacing={0.15}>
          A DIGITAL WORLD OF AI ENGINEERING
        </Text>
      </Billboard>
    </group>
  );
}
